/**
 * Firma hesapları — 3 şube × VakıfBank + Garanti.
 * Canlı Banka gönderen/alıcı etiketleri ve iç virman tanıma için.
 */

export const OWN_BANK_ACCOUNTS = [
  {
    bankingId: 'kavakli',
    branchLabel: 'Kavaklı',
    provider: 'garanti',
    bankLabel: 'Garanti',
    iban: 'TR680006200043200006285071',
    label: 'Kavaklı Garanti'
  },
  {
    bankingId: 'kavakli',
    branchLabel: 'Kavaklı',
    provider: 'vakifbank',
    bankLabel: 'VakıfBank',
    iban: 'TR720001500158007369019582',
    label: 'Kavaklı VakıfBank'
  },
  {
    bankingId: 'sefakoy-sube',
    branchLabel: 'Sefaköy Şube',
    provider: 'garanti',
    bankLabel: 'Garanti',
    iban: 'TR410006200043200006285363',
    label: 'Sefaköy Şube Garanti'
  },
  {
    bankingId: 'sefakoy-sube',
    branchLabel: 'Sefaköy Şube',
    provider: 'vakifbank',
    bankLabel: 'VakıfBank',
    iban: 'TR300001500158007311877347',
    label: 'Sefaköy Şube VakıfBank'
  },
  {
    bankingId: 'sefakoy-merkez',
    branchLabel: 'Sefaköy Merkez',
    provider: 'garanti',
    bankLabel: 'Garanti',
    iban: 'TR500006200043200006287335',
    label: 'Sefaköy Merkez Garanti'
  },
  {
    bankingId: 'sefakoy-merkez',
    branchLabel: 'Sefaköy Merkez',
    provider: 'vakifbank',
    bankLabel: 'VakıfBank',
    iban: 'TR420001500158007302981843',
    label: 'Sefaköy Merkez VakıfBank'
  }
];

export const normalizeOwnIbanKey = (iban) =>
  String(iban || '')
    .replace(/\s+/g, '')
    .toUpperCase();

const OWN_IBAN_LABEL_MAP = OWN_BANK_ACCOUNTS.reduce((acc, row) => {
  acc[normalizeOwnIbanKey(row.iban)] = row.label;
  return acc;
}, {});

/** IBAN bizim hesaplarımızdan biri mi? Etiket döner, değilse ''. */
export const resolveOwnAccountLabelByIban = (iban) => {
  const key = normalizeOwnIbanKey(iban);
  if (!key || key.length < 15) return '';
  return OWN_IBAN_LABEL_MAP[key] || '';
};

export const isOwnCompanyIban = (iban) => Boolean(resolveOwnAccountLabelByIban(iban));

/** İsim bizim hesap etiketimiz mi? (Kavaklı Garanti, Sefaköy Şube VakıfBank, …) */
export const isOwnBankAccountPartyName = (name) => {
  const folded = String(name || '')
    .toLocaleUpperCase('tr-TR')
    .replace(/İ/g, 'I')
    .replace(/Ş/g, 'S')
    .replace(/Ğ/g, 'G')
    .replace(/Ü/g, 'U')
    .replace(/Ö/g, 'O')
    .replace(/Ç/g, 'C')
    .replace(/[^A-Z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!folded) return false;
  return OWN_BANK_ACCOUNTS.some((row) => {
    const labelFolded = String(row.label || '')
      .toLocaleUpperCase('tr-TR')
      .replace(/İ/g, 'I')
      .replace(/Ş/g, 'S')
      .replace(/Ğ/g, 'G')
      .replace(/Ü/g, 'U')
      .replace(/Ö/g, 'O')
      .replace(/Ç/g, 'C')
      .replace(/[^A-Z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return labelFolded && folded === labelFolded;
  });
};

/**
 * Gönderen/alıcı IBAN’ı bizim hesapsa şube+banka etiketi yazar.
 * Mehmet Demirsoy görünen kendi hesap tarafını da ownIban ile etiketler.
 */
export const applyOwnAccountPartyLabels = ({
  senderName = '',
  receiverName = '',
  senderIban = '',
  receiverIban = '',
  ownIban = '',
  direction = ''
} = {}) => {
  let nextSender = String(senderName || '').trim();
  let nextReceiver = String(receiverName || '').trim();

  const senderLabel = resolveOwnAccountLabelByIban(senderIban);
  const receiverLabel = resolveOwnAccountLabelByIban(receiverIban);
  if (senderLabel) nextSender = senderLabel;
  if (receiverLabel) nextReceiver = receiverLabel;

  const ownLabel = resolveOwnAccountLabelByIban(ownIban);
  if (ownLabel) {
    const dir = String(direction || '').trim().toLowerCase();
    if (dir === 'in') {
      if (!receiverLabel) nextReceiver = ownLabel;
    } else if (dir === 'out') {
      if (!senderLabel) nextSender = ownLabel;
    }
  }

  return {
    senderName: nextSender,
    receiverName: nextReceiver
  };
};
